import { Body1, H4 } from "melodies-source/Text";
import React from "react";
import { styled } from "styled-components";

interface Props {
  children: React.ReactNode;
  className?: string;
  gap?: string;
}
export const TwoColumns: React.FC<Props> = ({
  children,
  className,
  gap = "50px",
}) => {
  return (
    <Container className={className} gap={gap}>
      {children}
    </Container>
  );
};

type ContainerProps = Pick<Props, "gap">;

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: flex-start;
  gap: ${({ gap }) => gap};

  & > * {
    width: 50%;
  }

  ${H4}, ${Body1} {
    color: #333;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    gap: 15px;

    & > * {
      width: 100%;
    }

    & > :first-child {
      ${H4} {
        font-size: 15px;
        line-height: 22px;
        font-weight: 600;
      }

      ${Body1}, a {
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
`;
